import React, { PureComponent } from 'react';
import gettext from 'js-utils/gettext';
import Modal from 'eventbrite_design_system/modal/Modal';
import Illustration from 'eventbrite_design_system/illustration/Illustration';
import Divider from 'eventbrite_design_system/divider/Divider';

import BlueMoneyIllustrationSvg from 'eventbrite_design_system/iconography/icons/BlueMoneyIllustration';

import './feeBreakdownModal.scss';

const ItemRow = ({ label, value }) => (
    <div className="eds-l-pad-bot-1">
        <div className="eds-g-cell eds-g-cell-6-12">{label}</div>
        <div className="eds-g-cell eds-g-cell-6-12">
            <div className="eds-align--right">{value}</div>
        </div>
    </div>
);

const ItemHeading = ({ children }) => (
    <div className="eds-text-weight--heavy eds-l-pad-bot-2">{children}</div>
);

const FeeBreakdown = ({
    passOnFees,
    processingFee,
    processingFeeTax,
    serviceFee,
    ticketRevenue,
    attendeeTotal,
    serviceFeeTax,
}) => {
    const preFeeSymbol = passOnFees ? '' : '-';
    const priceValue = passOnFees ? ticketRevenue : attendeeTotal;

    const feeRows = (
        <div>
            <ItemRow label={gettext('Ticket price')} value={priceValue} />
            <ItemRow
                label={gettext('Service fee')}
                value={`${preFeeSymbol}${serviceFee}`}
            />
            <ItemRow
                label={gettext('Processing fee')}
                value={`${preFeeSymbol}${processingFee}`}
            />
            {serviceFeeTax && (
                <ItemRow
                    label={gettext('Service fee tax')}
                    value={`${preFeeSymbol}${serviceFeeTax}`}
                />
            )}
            {processingFeeTax && (
                <ItemRow
                    label={gettext('Processing fee tax')}
                    value={`${preFeeSymbol}${processingFeeTax}`}
                />
            )}
            <div className="eds-l-pad-vert-1">
                <Divider />
            </div>
        </div>
    );

    return (
        <section className="eds-l-pad-top-4">
            <div className="eds-text-color--grey-600 eds-text-bm">
                <ItemHeading>{gettext('Cost to buyer')}</ItemHeading>
                <div className="eds-l-pad-bot-2">
                    {passOnFees && feeRows}
                    <ItemRow label={gettext('Total')} value={attendeeTotal} />
                </div>
                <ItemHeading>{gettext('Your payout')}</ItemHeading>
                <div className="eds-l-pad-bot-2">
                    {!passOnFees && feeRows}
                    <ItemRow
                        label={gettext('Ticket revenue')}
                        value={ticketRevenue}
                    />
                </div>
            </div>
        </section>
    );
};

const IllustrationComponent = (
    <div className="modal-illustration">
        <div className="modal-illustration__content blue-money-modal-content">
            <Illustration
                type={<BlueMoneyIllustrationSvg />}
                height="420px"
                width="285px"
            />
        </div>
    </div>
);

class FeeBreakdownModal extends PureComponent {
    state = { isShown: false };

    _handleOnOpen = () => {
        this.setState({ isShown: true });
    };

    _handleClose() {
        this.setState({ isShown: false });
    }

    render() {
        const {
            attendeeTotal,
            passOnFees,
            processingFee,
            processingFeeTax,
            serviceFee,
            serviceFeeTax,
            ticketRevenue,
        } = this.props;

        return (
            <div className="eds-g-grid pricing-calculator--fee-modal">
                <div className="eds-g-cell eds-g-cell-1-1">
                    <Modal
                        isShown={this.state.isShown}
                        illustration={IllustrationComponent}
                        onClose={this._handleClose.bind(this)}
                        onPrimaryAction={this._handleClose.bind(this)}
                        primaryText={gettext('Done')}
                        primaryType="link"
                    >
                        <FeeBreakdown
                            passOnFees={passOnFees}
                            serviceFee={serviceFee}
                            processingFee={processingFee}
                            processingFeeTax={processingFeeTax}
                            attendeeTotal={attendeeTotal}
                            ticketRevenue={ticketRevenue}
                            serviceFeeTax={serviceFeeTax}
                        />
                    </Modal>
                    {this.props.children(this._handleOnOpen)}
                </div>
            </div>
        );
    }
}

export default FeeBreakdownModal;
